/*
 * @Author: zyb
 * @Date: 2022-03-22 19:04:12
 * @LastEditors: zyb
 * @LastEditTime: 2022-04-18 16:47:02
 * @FilePath: \dev_2.0\src\utils\index.js
 * @Description: 
 */
export default {
  tips: function(type = "tips", Message = "服务器错误") {
    Message({
      type: type,
      message: message,
      center: false,
      offset: 100, //距离顶部的距离
      duration: 3000,
    });
  },
};
